import axios from 'axios';
import {API_ROOT, translate} from "../app/utils";
import store from '../store';
import {refreshLabels} from './contactsGroupItemActions';
import {getProfile} from './profileActions';
import {userUnShareErrorPopup} from "./popupActions";
import {flash} from './sharingDetailsActions';

export function findUsers(status, licensed, role){
	return function(dispatch) {

		if(role){
			if(status){
				if(licensed){

					axios.get(API_ROOT + "/api/v3/users/license?status=" + status + "&licenseStatus=" + licensed + "&role=" + role, {withCredentials: true}).then((response) => {
						dispatch({
							type: "FIND_USERS",
							payload: response.data
						});

						dispatch(animationUsersListDisplay());
					});

				} else {
					axios.get(API_ROOT + "/api/v3/users/license?status=" + status + "&role=" + role, {withCredentials: true}).then((response) => {
						dispatch({
							type: "FIND_USERS",
							payload: response.data
						});

						dispatch(animationUsersListDisplay());
					});
				}
			} else {
				if(licensed){

					axios.get(API_ROOT + "/api/v3/users/license?licenseStatus=" + licensed + "&role=" + role, {withCredentials: true}).then((response) => {
						dispatch({
							type: "FIND_USERS",
							payload: response.data
						});

						dispatch(animationUsersListDisplay());
					});

				} else {
					axios.get(API_ROOT + "/api/v3/users/license?role=" + role, {withCredentials: true}).then((response) => {
						dispatch({
							type: "FIND_USERS",
							payload: response.data
						});

						dispatch(animationUsersListDisplay());
					});
				}
			}
		} else {
			if(status){
				if(licensed){

					axios.get(API_ROOT + "/api/v3/users/license?status=" + status + "&licenseStatus=" + licensed, {withCredentials: true}).then((response) => {
						dispatch({
							type: "FIND_USERS",
							payload: response.data
						});

						dispatch(animationUsersListDisplay());
					});

				} else {
					axios.get(API_ROOT + "/api/v3/users/license?status=" + status, {withCredentials: true}).then((response) => {
						dispatch({
							type: "FIND_USERS",
							payload: response.data
						});

						dispatch(animationUsersListDisplay());
					});
				}
			} else {
				if(licensed){

					axios.get(API_ROOT + "/api/v3/users/license?licenseStatus=" + licensed, {withCredentials: true}).then((response) => {
						dispatch({
							type: "FIND_USERS",
							payload: response.data
						});

						dispatch(animationUsersListDisplay());
					});

				} else {
					axios.get(API_ROOT + "/api/v3/users/license", {withCredentials: true}).then((response) => {
						dispatch({
							type: "FIND_USERS",
							payload: response.data
						});

						dispatch(animationUsersListDisplay());
					});
				}
			}
		}


	}
}

export function animationUsersListDisplay(){

	return function(){
		if(document.querySelectorAll('.users > div').length > 0){

			document.querySelectorAll('.users > div').forEach((item, index) => {
				if(item.classList.contains('appearing')){
					setTimeout(() => {
						item.classList.remove('appearing');
					}, 100 + index * 50);
				}
			});

		}
	}

}

export function usersListFilteredStatus(string){
    return {
        type: "USERS_LIST_FILTERED_STATUS",
        payload: string
	}
}

export function usersListFilteredLicense(string){
    return {
        type: "USERS_LIST_FILTERED_LICENSE",
        payload: string
    }
}

export function usersListFilteredRole(string) {
	return {
		type: "USERS_LIST_FILTERED_ROLE",
		payload: string
	}
}

export function postFreeLicense(userId){
	return function (dispatch) {
		axios.post(API_ROOT + '/v2/api/labels/userUnShareAll?userId=' + userId, {}, {withCredentials: true}).then((response) => {
			dispatch(refreshLabels());
			dispatch(findUsers(store.getState().usersListReducer.usersListFilteredStatus, store.getState().usersListReducer.usersListFilteredLicense));
			dispatch(flash({type: 'success', message: response.data.message}));
			dispatch(getProfile())
		}).catch((e) => {
			if(e.response.data.message === "You need to remove this user from the following groups in Google Admin Console"){
				dispatch(userUnShareErrorPopup([e.response.data]));
			} else {
				dispatch(flash({type: 'danger', message: translate("textPostFreeLicenseError")}));
			}
		});
	}
}

export function postFreeLicenseByLabel(userId, labelId, labelName, labelOwnerId){
	return function (dispatch) {

		let payload = {
			"id": labelId,
			"ownerId": labelOwnerId
		};

		axios.post(API_ROOT + '/v2/api/labels/userUnShare?userId=' + userId, payload, {withCredentials: true}).then(() => {
			dispatch(refreshLabels());
			dispatch(findUsers(store.getState().usersListReducer.usersListFilteredStatus, store.getState().usersListReducer.usersListFilteredLicense));
			dispatch(flash({type: 'success', message: translate("textPostFreeLicenseByLabelSuccess").replace("{{labelName}}", labelName )}));
			dispatch(getProfile())
		}).catch((e) => {
			if(e.response.data.message.includes("You need to remove this user from the following groups in Google Admin Console")){
				dispatch(userUnShareErrorPopup([e.response.data, labelName]));
			} else {
				dispatch(flash({type: 'danger', message: translate("textPostFreeLicenseByLabelError").replace("{{labelName}}", labelName )}));
			}
		});
	}
}

function refreshUsers () {
	return function (dispatch, getState) {
		if(getState().usersListReducer.usersListFilteredRole) {
			if (getState().usersListReducer.usersListFilteredLicense) {
				if (getState().usersListReducer.usersListFilteredStatus) {
					dispatch(findUsers(
						getState().usersListReducer.usersListFilteredStatus,
						getState().usersListReducer.usersListFilteredLicense,
						getState().usersListReducer.usersListFilteredRole
					));
				} else {
					dispatch(findUsers(
						null,
						getState().usersListReducer.usersListFilteredLicense,
						getState().usersListReducer.usersListFilteredRole
					));
				}
			} else {
				if (getState().usersListReducer.usersListFilteredStatus) {
					dispatch(findUsers(
						getState().usersListReducer.usersListFilteredStatus,
						null,
						getState().usersListReducer.usersListFilteredRole
					));
				} else {
					dispatch(findUsers(
						null,
						null,
						getState().usersListReducer.usersListFilteredRole
					));
				}
			}
		} else {
			if (getState().usersListReducer.usersListFilteredLicense) {
				if (getState().usersListReducer.usersListFilteredStatus) {
					dispatch(findUsers(
						getState().usersListReducer.usersListFilteredStatus,
						getState().usersListReducer.usersListFilteredLicense
					));
				} else {
					dispatch(findUsers(
						null,
						getState().usersListReducer.usersListFilteredLicense
					));
				}
			} else {
				if (getState().usersListReducer.usersListFilteredStatus) {
					dispatch(findUsers(
						getState().usersListReducer.usersListFilteredStatus,
						null
					));
				} else {
					dispatch(findUsers());
				}
			}
		}
	}
}
export function putUpdateRole (object) {
	return function (dispatch) {
		axios.put(API_ROOT + "/api/v2/users/license/role", object, {withCredentials: true}).then(() => {
			dispatch(flash({type: 'success', message: 'The role of the user has been successfully updated!'}));
		}).catch(e => {
			switch (e.response.data) {
				case 'Cannot update role of Cross Domain User':
					dispatch(flash({type: 'danger', message: 'You cannot update role of a cross domain user.'}));
					break;
				case 'Updating your own role is not permitted':
					dispatch(flash({type: 'danger', message: 'You cannot update your own role.'}));
					break;
				default:
					dispatch(flash({type: 'danger', message: 'The update cannot proceed. Please contact our Support if the problem persists.'}));
					break;
			}
		}).finally(() => {
			dispatch(refreshUsers());
		});
	}
}

export function getAdministrators () {
	return function (dispatch) {
		axios.get(API_ROOT + "/api/v2/users/license/administrators", {withCredentials: true}).then((response) => {
			dispatch({
				type: "GET_ADMINISTRATORS",
				payload: response.data
			});
		});
	}
}
